import * as React from 'react';

/**
 * "Sitenize ekleyin" — otelin kendi web sitesine rezervasyon modulunu
 * gomecegi kopyala-yapistir kodu.
 *
 * Sayfa hicbir uca istek atmaz: adres tarayicidan (`location.origin`) gelir,
 * yani otel hangi adresten baktiysa dogru kod uretilir.
 */

const KOPYA_SURESI_MS = 1600;

export function SiteyeEkle() {
  const kaynak = typeof location !== 'undefined' ? location.origin : 'https://otelcms.com';

  const scriptKodu = `<div id="otelcms-rezervasyon"></div>\n<script src="${kaynak}/embed.js" async></script>`;
  const iframeKodu = `<iframe src="${kaynak}/rezervasyon/embed"\n        title="Online rezervasyon"\n        style="width:100%;border:0;min-height:900px"\n        scrolling="no"></iframe>`;
  const dogrudanLink = `${kaynak}/rezervasyon`;

  return (
    <main className="flex flex-1 flex-col gap-[22px] bg-zemin p-5 sm:p-7">
      <div className="flex flex-wrap items-center gap-3.5 [animation:rise_.5s_cubic-bezier(.2,.7,.2,1)_both]">
        <h1 className="text-3xl font-bold tracking-[-.03em]">Sitenize ekleyin</h1>
        <span className="text-sm text-gri">
          Rezervasyon modülünü kendi web sitenize yerleştirin — kod bilgisi gerekmez.
        </span>
      </div>

      <div className="grid items-start gap-[18px] xl:grid-cols-[minmax(0,1fr)_minmax(360px,420px)]">
        <div className="flex flex-col gap-[18px]">
          <Kutu
            adim="1"
            baslik="Kodu kopyalayın"
            aciklama="Sitenizde rezervasyon formunun görünmesini istediğiniz yere yapıştırın. Genişliği kendiliğinden ayarlanır; dar bir sütuna koyarsanız mobil düzene geçer."
          >
            <KodKutusu kod={scriptKodu} etiket="Önerilen" />
            <p className="text-[13px] leading-relaxed text-gri">
              Bu kod sayfanıza bir çerçeve ekler ve yüksekliğini içeriğe göre kendisi ayarlar; ziyaretçi adım
              değiştirdikçe form uzayıp kısalır, sayfanızda kaydırma çubuğu çıkmaz.
            </p>
          </Kutu>

          <Kutu
            adim="2"
            baslik="Script eklenemiyorsa"
            aciklama="Bazı site kurucular (bazı Wix / Shopify planları, bazı WordPress editörleri) <script> etiketini siler. O durumda bu ikinci kodu kullanın."
          >
            <KodKutusu kod={iframeKodu} etiket="Alternatif" />
            <p className="text-[13px] leading-relaxed text-gri">
              Bu sürümde yükseklik sabittir (900 piksel). Form kısaldığında altta boşluk kalabilir; sorun olursa
              <code className="mx-1 rounded bg-zemin px-1.5 py-0.5 text-[12px]">min-height</code>
              değerini kendi sitenize göre değiştirin.
            </p>
          </Kutu>

          <Kutu
            adim="3"
            baslik="Ya da sadece bağlantı verin"
            aciklama="Menünüze “Rezervasyon” düğmesi eklemek yeterliyse, gömmeye gerek yok."
          >
            <KodKutusu kod={dogrudanLink} etiket="Bağlantı" tekSatir />
            <p className="text-[13px] leading-relaxed text-gri">
              Bu adres tam sayfa çalışır ve otelinizin adını, telefonunu üst bantta gösterir.
            </p>
          </Kutu>

          <div className="flex flex-col gap-3 rounded-[20px] border border-cizgi bg-white p-5">
            <h3 className="text-[15px] font-bold text-lacivert">Bilmeniz gerekenler</h3>
            <Madde>
              Modül <strong className="text-lacivert">bu tesise</strong> bağlıdır: kodu kopyaladığınız adres
              ({kaynak.replace('https://', '')}) hangi oteli gösteriyorsa, ziyaretçiler o otelin müsaitliğini görür.
            </Madde>
            <Madde>
              Fiyatlar ve boş odalar buradaki tarifenizden <strong className="text-lacivert">canlı</strong> gelir.
              Ayrı bir yerde güncelleme yapmanız gerekmez.
            </Madde>
            <Madde>
              Gelen rezervasyonlar oda planında “Onaylı” olarak görünür ve boş bir oda kendiliğinden atanır; planı
              sürükleyerek odayı değiştirebilirsiniz.
            </Madde>
            <Madde>
              Ödeme <strong className="text-lacivert">otelde</strong> alınır. Modül kart bilgisi istemez ve saklamaz;
              online tahsilat için ödeme sağlayıcısı entegrasyonu gerekir.
            </Madde>
            <Madde>
              Modülü hangi siteye koyacağınız kısıtlı değildir. Yalnızca kendi alan adınıza koymak isterseniz bize
              yazın, o adrese kilitleyelim.
            </Madde>
          </div>
        </div>

        <aside className="flex flex-col gap-3 [animation:rise_.6s_.1s_cubic-bezier(.2,.7,.2,1)_both] xl:sticky xl:top-[92px]">
          <div className="flex items-center justify-between">
            <h3 className="text-[15px] font-bold text-lacivert">Canlı önizleme</h3>
            <a
              href="/rezervasyon"
              target="_blank"
              rel="noreferrer"
              className="text-[13px] font-semibold text-marka-600 hover:underline"
            >
              Tam sayfa aç →
            </a>
          </div>
          <p className="text-[13px] leading-relaxed text-gri">
            Aşağıdaki, ziyaretçilerinizin göreceğinin aynısıdır — dar bir çerçevede olduğu için mobil düzende
            görünür.
          </p>
          <div className="overflow-hidden rounded-[20px] border border-cizgi bg-white">
            <div className="flex items-center gap-2 border-b border-cizgi bg-[#fbfcfe] px-3.5 py-2.5">
              {['#e5484d', '#f2b632', '#12a150'].map((r) => (
                <span key={r} className="size-2.5 rounded-full" style={{ background: r }} />
              ))}
              <span className="ml-2 truncate text-xs text-gri">otelinizinsitesi.com</span>
            </div>
            <iframe
              src="/rezervasyon/embed"
              title="Rezervasyon modülü önizlemesi"
              className="block h-[620px] w-full border-0"
            />
          </div>
        </aside>
      </div>
    </main>
  );
}

function Kutu({
  adim,
  baslik,
  aciklama,
  children,
}: {
  adim: string;
  baslik: string;
  aciklama: string;
  children: React.ReactNode;
}) {
  return (
    <section className="flex flex-col gap-3.5 rounded-[20px] border border-cizgi bg-white p-5 [animation:rise_.5s_both]">
      <div className="flex items-start gap-3">
        <span className="grid size-7 flex-none place-items-center rounded-full bg-lacivert text-[13px] font-bold text-white">
          {adim}
        </span>
        <div className="flex flex-col gap-1">
          <h2 className="text-[17px] font-bold tracking-[-.01em] text-lacivert">{baslik}</h2>
          <p className="text-[13.5px] leading-relaxed text-gri">{aciklama}</p>
        </div>
      </div>
      {children}
    </section>
  );
}

function KodKutusu({ kod, etiket, tekSatir }: { kod: string; etiket: string; tekSatir?: boolean }) {
  const [kopyalandi, setKopyalandi] = React.useState(false);

  async function kopyala() {
    try {
      await navigator.clipboard.writeText(kod);
    } catch {
      // Pano izni yoksa kullanici elle secebilsin diye metni isaretleriz.
      const alan = document.getElementById(`kod-${etiket}`);
      if (alan) {
        const secim = window.getSelection();
        const aralik = document.createRange();
        aralik.selectNodeContents(alan);
        secim?.removeAllRanges();
        secim?.addRange(aralik);
      }
      return;
    }
    setKopyalandi(true);
    setTimeout(() => setKopyalandi(false), KOPYA_SURESI_MS);
  }

  return (
    <div className="relative overflow-hidden rounded-[14px] bg-lacivert">
      <div className="flex items-center justify-between gap-3 border-b border-white/10 px-4 py-2.5">
        <span className="text-[11px] font-bold uppercase tracking-[.08em] text-mavi-acik">{etiket}</span>
        <button
          type="button"
          onClick={kopyala}
          className="flex items-center gap-1.5 rounded-lg bg-white/[.12] px-2.5 py-1.5 text-xs font-semibold text-white transition hover:bg-white/[.22]"
        >
          {kopyalandi ? (
            <>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#5fd48f" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="m5 12.5 4.5 4.5L19 7" />
              </svg>
              Kopyalandı
            </>
          ) : (
            <>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="9" y="9" width="12" height="12" rx="2.5" />
                <path d="M15 6V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h1" />
              </svg>
              Kopyala
            </>
          )}
        </button>
      </div>
      <pre
        id={`kod-${etiket}`}
        className={
          'overflow-x-auto px-4 py-3.5 text-[12.5px] leading-relaxed text-[#d7e0f7] ' +
          (tekSatir ? 'whitespace-nowrap' : 'whitespace-pre')
        }
      >
        {kod}
      </pre>
    </div>
  );
}

function Madde({ children }: { children: React.ReactNode }) {
  return (
    <p className="flex gap-2.5 text-[13.5px] leading-relaxed text-gri">
      <span className="mt-[7px] size-1.5 flex-none rounded-full bg-marka-600" />
      <span>{children}</span>
    </p>
  );
}
